module.exports = __webpack_public_path__ + "static/media/0006.bd76659.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0006.mp3
// module id = dhWo
// module chunks = 0